import * as actions from "./../actions/actionTypes";
const initState = {
	state: false,
	message: ''
};
const loginErrorReducer = (state = initState, action) => {
  switch (action.type) {
    case actions.LOGIN_ERROR:
      return action.payload;
    default:
      return state;
  }
};

export default loginErrorReducer;
